import { render } from "./PaymentDescription.vue?vue&type=template&id=fdc7ca1c&lang=pug"
import script from "./PaymentDescription.vue?vue&type=script&lang=js"
export * from "./PaymentDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__